{
  "$description": "AUTOMATISCH GENERIERT aus brand/tokens.json. Nicht von Hand ändern, sondern die Quelle bearbeiten und `npm run tokens:build` laufen lassen. Rollen (--cd-ui-*) je Modus, für Renderer, Exporte, Drift-Tests und Hosts. Renderer zeichnen und exportieren mit hell, dunkel kommt nur über CSS. hochkontrast enthält die Rollen, die sich bei data-cd-kontrast=\"hoch\" ändern. fest sind die Farben, die in beiden Modi gleich bleiben. shell sind die Maße und Ebenen der App-Shell der Modeler (Einpassen, Breakpoint, z-index), mit denselben Werten wie --cd-shell-* in der CSS.",
  "hell": {
    "--cd-ui-grund": "#F9F7F7",
    "--cd-ui-flaeche": "#FFFFFF",
    "--cd-ui-flaeche-hoch": "#FFFFFF",
    "--cd-ui-hover": "#EEF1FD",
    "--cd-ui-plot": "#FFFFFF",
    "--cd-ui-seite": "#FFFFFF",
    "--cd-ui-abschnitt": "#F9F7F7",
    "--cd-ui-linie": "#E6E2E2",
    "--cd-ui-kontur": "#8F8A8A",
    "--cd-ui-text": "#1D1D1D",
    "--cd-ui-text-leise": "#6B6666",
    "--cd-ui-link": "#2B50D4",
    "--cd-ui-icon-akzent": "#335DE5",
    "--cd-ui-fokus": "#2B50D4",
    "--cd-ui-interaktion": "#335DE5",
    "--cd-ui-success": "#00E676",
    "--cd-ui-warning": "#FFB000",
    "--cd-ui-danger": "#CD1839",
    "--cd-ui-info": "#335DE5",
    "--cd-ui-success-flaeche": "#DAFBEB",
    "--cd-ui-warning-flaeche": "#FFF1D2",
    "--cd-ui-danger-flaeche": "#FBEEF0",
    "--cd-ui-info-flaeche": "#EEF1FD",
    "--cd-ui-wortmarke": "#00E676",
    "--cd-ui-backdrop": "rgba(29, 29, 29, 0.42)",
    "--cd-ui-chrome-deckkraft": "84%"
  },
  "dunkel": {
    "--cd-ui-grund": "#1D1D1D",
    "--cd-ui-flaeche": "#282828",
    "--cd-ui-flaeche-hoch": "#2F2F2F",
    "--cd-ui-hover": "#383838",
    "--cd-ui-plot": "#1D1D1D",
    "--cd-ui-seite": "#1D1D1D",
    "--cd-ui-abschnitt": "#282828",
    "--cd-ui-linie": "#464646",
    "--cd-ui-kontur": "#8F8A8A",
    "--cd-ui-text": "#FFFFFF",
    "--cd-ui-text-leise": "#BBBBBB",
    "--cd-ui-link": "#00E676",
    "--cd-ui-icon-akzent": "#00E676",
    "--cd-ui-fokus": "#6B8AFF",
    "--cd-ui-interaktion": "#6B8AFF",
    "--cd-ui-success": "#00E676",
    "--cd-ui-warning": "#FFB000",
    "--cd-ui-danger": "#FB6D73",
    "--cd-ui-info": "#6B8AFF",
    "--cd-ui-success-flaeche": "#282828",
    "--cd-ui-warning-flaeche": "#282828",
    "--cd-ui-danger-flaeche": "#282828",
    "--cd-ui-info-flaeche": "#282828",
    "--cd-ui-wortmarke": "#FFFFFF",
    "--cd-ui-backdrop": "rgba(29, 29, 29, 0.6)",
    "--cd-ui-chrome-deckkraft": "100%"
  },
  "hochkontrast": {
    "hell": {
      "--cd-ui-linie": "#8F8A8A",
      "--cd-ui-kontur": "#1D1D1D",
      "--cd-ui-text-leise": "#1D1D1D",
      "--cd-ui-chrome-deckkraft": "100%"
    },
    "dunkel": {
      "--cd-ui-linie": "#8F8A8A",
      "--cd-ui-kontur": "#FFFFFF",
      "--cd-ui-text-leise": "#FFFFFF",
      "--cd-ui-chrome-deckkraft": "100%"
    }
  },
  "fest": {
    "--cd-blau": "#335DE5",
    "--cd-gruen": "#00E676",
    "--cd-grau": "#F9F7F7",
    "--cd-schwarz": "#1D1D1D",
    "--cd-weiss": "#FFFFFF",
    "--cd-blau-link": "#2B50D4",
    "--cd-blau-hell": "#6B8AFF",
    "--cd-success": "#00E676",
    "--cd-success-soft": "#DAFBEB",
    "--cd-success-hell": "#00E676",
    "--cd-warning": "#FFB000",
    "--cd-warning-soft": "#FFF1D2",
    "--cd-warning-hell": "#FFB000",
    "--cd-danger": "#CD1839",
    "--cd-danger-soft": "#FBEEF0",
    "--cd-danger-hell": "#FB6D73",
    "--cd-info": "#335DE5",
    "--cd-info-soft": "#EEF1FD",
    "--cd-info-hell": "#6B8AFF",
    "--cd-linie": "#E6E2E2",
    "--cd-kontur": "#8F8A8A",
    "--cd-text-leise": "#6B6666"
  },
  "shell": {
    "--cd-shell-rand": "12px",
    "--cd-shell-luecke": "8px",
    "--cd-shell-zeile": "40px",
    "--cd-shell-ziel": "32px",
    "--cd-shell-eintrag": "36px",
    "--cd-shell-frei": "64px",
    "--cd-shell-menue-breite": "248px",
    "--cd-shell-inspector-breite": "288px",
    "--cd-shell-einpassen-oben": "88px",
    "--cd-shell-einpassen-oben-schmal": "140px",
    "--cd-shell-einpassen-seite": "24px",
    "--cd-shell-einpassen-unten": "64px",
    "--cd-shell-einpassen-unten-web": "92px",
    "--cd-shell-schmal": "760px",
    "--cd-shell-sehr-schmal": "440px",
    "--cd-shell-niedrig": "820px",
    "--cd-shell-ebene-inseln": "20",
    "--cd-shell-ebene-inspector": "25",
    "--cd-shell-ebene-reihe": "30",
    "--cd-shell-ebene-aufklapper": "40",
    "--cd-shell-ebene-dialog": "50",
    "--cd-shell-ebene-toast": "60"
  }
}
